import MenuMobile from '@/components/MenuMobile/index.vue';
import Avatar from '@/components/Avatar/index.vue';
import UsersService from '/src/services/users.service';

export default {
    name: 'MenuUser',

    props: ['image', 'notifications', 'showDropdownMenu', 'menuMobileVisible'],

    components: {
        MenuMobile,
        Avatar
    },

    data() {
        return {
            profileSections: [
                {
                    key: '/profile',
                    title: 'Mi perfil'
                },
                {
                    key: '/account/config',
                    title: 'Config. de cuentas'
                },
                {
                    key: '/account/documents',
                    title: 'Documentación'
                },
                {
                    key: '/account/iiff',
                    title: 'Informes fiscales'
                },
                {
                    key: '/account/notifications',
                    title: 'Notificaciones'
                }
            ]
        };
    },

    methods: {
        logout() {
            localStorage.clear();
            this.$store.dispatch('setDefaultStore');
            this.$root.$emit('refreshLayout');

            if (localStorage.getItem('ADMIN')) {
                this.$router.push({ name: 'login' });
            } else {
                this.$router.push({ name: 'login', params: { advice: true } });
            }
        },
        closeThis() {
            this.$refs.avatarDropdown.hide(true);
            this.$root.$emit('loadDocumentNotification');
        }
    },

    computed: {
        currentUser() {
            if (!this.intervener) return '';

            const lastname_1 = this.intervener.lastname_1 ? this.intervener.lastname_1 : '';
            const lastname_2 = this.intervener.lastname_2 ? this.intervener.lastname_2 : '';

            return `${this.intervener.name} ${lastname_1} ${lastname_2}`;
        },

        getUserInitials() {
            if (!this.intervener) return '';

            const abbr = `${this.intervener.name.substring(
                0,
                1
            )}${this.intervener.lastname_1.substring(0, 1)}`;

            return abbr;
        },

        intervener() {
            return UsersService.getIntervenerFromLocalStore();
        }
    }
};
